export default __webpack_public_path__ + "media/5862dd37a5b1e4ac877ce1eda8deaf22107b1c75c0dc005bce45c94ea0e9437d.svg";